import { Subject } from 'rxjs';

export const resetCommonShareDialog: Subject<any> = new Subject<any>();
export const image_extensions = ['jpg', 'png', 'jpeg', 'bmp'];
export const heic_extensions = ['heic', 'heif', 'jfif'];
export const acceptImageExtensions = '.jpg, .png, .jpeg, .bmp, .heic, .heif';
export const file_extensions_pdf_doc = ['pdf', 'doc', 'docx'];
export const video_extensions = [
  '.mp4',
  '.wmv',
  '.flv',
  '.avi',
  '.wav',
  '.mov',
  '.webm',
  '.m4v',
  '.m4a',
  '.f4v',
  '.f4a',
  '.m4b',
  '.m4r',
  '.f4b',
  '.3gp',
  '.3gp2',
  '.3g2',
  '.3gpp',
  '.3gpp2',
  '.wma',
  '.VOB',
  '.LXF',
  '.MXF',
  '.MJPG',
  '.MJPEG',
  '.mpg',
  '.mkv'
];
